import { FC, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@getsynapse/design-system';
import { useAppThunkDispatch } from 'state/store';
import {
  selectViewSettingValues,
  createUpdateUserViewSetting,
} from 'state/ViewSettings/viewSettingsSlice';
import { PROJECTS_LIST_VIEW_MODE } from 'utils/constants';
import boardView from 'assets/icons/board-view.svg';
import tableView from 'assets/icons/table-view.svg';
import { UserViewSettings } from 'utils/customTypes';
import ToggleButtonGroup from 'Molecules/ToggleButtonGroup/ToggleButtonGroup';

interface ViewModeToggleButtonProps {
  viewType: UserViewSettings;
  className?: string;
}

const ViewModeToggleButton: FC<ViewModeToggleButtonProps> = ({
  viewType,
  className,
}) => {
  const dispatch = useAppThunkDispatch();
  const projectViewValues = useSelector(
    selectViewSettingValues('PROJECT_VIEW_TYPE')
  );

  const viewModeOptions = useMemo(() => {
    return [
      {
        children: (isSelected: boolean) => (
          <Icon src={tableView} className='h-4' />
        ),
        key: PROJECTS_LIST_VIEW_MODE.TABLE,
        'data-cy': 'list-view-switch-button',
      },
      {
        children: (isSelected: boolean) => <Icon src={boardView} />,
        key: PROJECTS_LIST_VIEW_MODE.BOARD,
        'data-cy': 'board-view-switch-button',
      },
    ];
  }, []);

  const handleToggleViewMode = useCallback(
    (key: string) => {
      const view_settings_values_id = projectViewValues.find(
        (val) => val.value === key
      )?.view_settings_values_id;
      if (view_settings_values_id) {
        dispatch(
          createUpdateUserViewSetting({
            view_settings_id: viewType?.view_settings_id,
            view_settings_values_id,
          })
        );
        window.history.replaceState({}, '', window.location.pathname);
      }
    },
    [dispatch, projectViewValues, viewType?.view_settings_id]
  );

  return (
    <>
      {viewType && (
        <ToggleButtonGroup
          buttonsList={viewModeOptions}
          className={className}
          onChange={handleToggleViewMode}
          selected={viewType?.value}
        />
      )}
    </>
  );
};

export default ViewModeToggleButton;
